import { render, staticRenderFns } from "./ScoreVerify.vue?vue&type=template&id=4e07bad2"
import script from "./ScoreVerify.vue?vue&type=script&lang=js"
export * from "./ScoreVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports